module.exports = __webpack_public_path__ + "static/img/offshelf.989fb6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/offshelf.png
// module id = N8Bl
// module chunks = 18